import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error('Complete todos los campos'); return; }
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Bienvenido, ${user.name}`);
      if (user.role === 'admin') navigate('/admin');
      else navigate('/tienda');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8">
          <div className="mb-8">
            <h1 className="text-2xl font-display font-semibold tracking-tight">Iniciar Sesión</h1>
            <p className="text-sm text-muted-foreground mt-1">Ingresa a tu cuenta KIND TECHNOLOGIES</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div className="space-y-2">
              <Label>Correo electrónico</Label>
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="correo@ejemplo.com" data-testid="login-email" />
            </div>
            <div className="space-y-2">
              <Label>Contraseña</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
            </div>
            
            <div className="flex items-center justify-end">
              <Link to="/forgot-password" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
            
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? 'Ingresando...' : 'Iniciar Sesión'}
            </Button>
          </form>
          <p className="text-sm text-center text-muted-foreground mt-6">
            ¿No tienes cuenta? <Link to="/registro" className="text-foreground font-medium hover:underline">Regístrate</Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
